import { MouseEventHandler } from 'react';
import styles from './ActionIcon.module.css';

interface ActionIconProps {
  icon: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  /** Tooltip and accessible name - the icon alone says nothing to a screen reader. */
  title?: string;
}

const ActionIcon = ({ icon, onClick, title }: ActionIconProps) => {
  return (
    <button className={styles.button} onClick={onClick} title={title} aria-label={title}>
      <img src={icon} alt="" />
    </button>
  );
};

export default ActionIcon;
